<template>
  <div>
    <invoice-processing-search-box ref="searchBox" :pagestate="pageState" @ok="ok" />
    <div v-loading="tableLoading">
      <el-table :data="tableData" border>
        <el-table-column align="left" label="原始发货单号" width="180" prop="oldDeliveryNum">
          <template v-slot="{row}">
            <span class="FontColor" @click="lookApplyForDelivery(row,true)">{{ row.oldDeliveryNum }}</span>
          </template>
        </el-table-column>
        <el-table-column align="left" label="申请发货单号" width="180" prop="deliveryNum">
          <template v-slot="{row}">
            <span class="FontColor" @click="lookApplyForDelivery(row,false)">{{ row.deliveryNum }}</span>
          </template>
        </el-table-column>
        <el-table-column align="left" header-align="left" label="项目名称" prop="projectName" width="150">
          <template v-slot="{row}">
            <span class="FontColor" @click="lookContract(row)">{{ row.projectName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="left" label="合同编号" prop="contractNum" width="150" />
        <el-table-column align="left" label="客户名称" width="180" prop="agentName" />
        <el-table-column align="left" label="订单分类" prop="contractType" width="120" />
        <el-table-column align="left" label="申请时间" width="140" prop="submitTime" />
        <el-table-column align="left" label="现销/赊销" width="80" prop="salesType">
          <template slot-scope="scope">
            <span>
              {{ scope.row.salesType === 1 ? '现销' : "赊销" }}
              <!-- 1 现销 2 赊销 3 LC -->
            </span>
          </template>
        </el-table-column>
        <el-table-column align="left" label="关务" width="120" prop="customsName" />
        <el-table-column align="left" label="国家" width="120" prop="overSeasSalesCountry" />
        <el-table-column align="right" header-align="left" label="分配比例" width="80" prop="proportion" />
        <el-table-column align="right" header-align="left" label="发货单未拆分总金额" width="150" prop="amountSum">
          <template v-slot="{row}">
            {{ row.amountSum ? Number(row.amountSum).toFixed(2) : '0.00' }}
          </template>
        </el-table-column>
        <el-table-column align="left" label="币种" width="80" prop="currencyName" />
        <el-table-column
          prop="physicalFlag"
          label="是否含非实物"
          align="left"
          width="80"
        >
          <template v-slot="{row}">
            {{ row.physicalFlag ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="batteryFlag"
          label="是否带电池"
          align="left"
          width="80"
        >
          <template v-slot="{row}">
            {{ row.batteryFlag ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column align="left" label="状态信息" prop="wmsStateDesc">
          <template v-slot="{ row }">
            <span v-if="row.wmsStateDesc">
              {{ row.wmsStateDesc }}
            </span>
            <span v-else>——</span>
          </template>
        </el-table-column>
        <!-- 是否抛转成功,根据是否有发货单号进行的判断的显示 -->
        <el-table-column align="left" label="是否抛转成功" prop="">
          <template v-slot="{ row }">
            <span v-if="row.invoiceNum">
              {{ '是' }}
            </span>
            <span v-else>——</span>
          </template>
        </el-table-column>
        <el-table-column align="left" label="发货单号" prop="invoiceNum" width="150">
          <template v-slot="{ row }">
            <el-button
              v-if="row.invoiceNum"
              style="user-select: all;"
              type="text"
              @click="lookShippingList(row)"
            >
              {{ row.invoiceNum }}
            </el-button>
            <span v-else>——</span>
          </template>
        </el-table-column>
        <el-table-column align="left" label="物流单号" width="180" prop="logisticsNum">
          <template v-slot="{ row }">
            <el-button type="text" @click="lookLogistics(row)">
              {{ row.logisticsNum }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      :page-sizes="[10, 20, 30, 40]"
      :page-size.sync="pageState.pageSize"
      :current-page.sync="pageState.currentPage"
      layout="->,total, prev, pager, next, jumper,sizes"
      :total="pageState.total"
      style="margin-top: 10px"
      @size-change="handlerSizeChange"
      @current-change="handlerCurrentChange"
    />
    <InternationalApplyForDeliveryDialog
      :current-click-data="currentClickData"
      :dialog-visible-from-apply-for-delivery="dialogVisibleFromApplyForDelivery"
      :is-detail="true"
      :is-origin-order-number="isOriginOrderNumber"
      :show-notes="2"
      is-distri-money
      @on-status-dialog="updateDialogVisibleFromApplyForDelivery"
      @refresh-table="refreshtable"
    />
    <InternationalShippingListDialog
      :current-click-data="currentClickData"
      :dialog-visible-from-shipping-list="dialogVisibleFromShippingList"
      @on-status-dialog="updateDialogVisibleFromShippingList"
    />
    <InternationalLogisticsInformationDialog
      :current-click-data="currentClickData"
      :dialog-visible-from-logistics="dialogVisibleFromLogistics"
      @on-status-dialog="updateDialogVisibleFromLogistics"
    />
  </div>
</template>

<script>
import InvoiceProcessingSearchBox from '@/views/InternationalInvoiceProcessing/InvoiceProcessingSearchBox.vue';
import InternationalApplyForDeliveryDialog from '@/views/business/components/InternationalApplyForDeliveryDialog.vue';
import InternationalLogisticsInformationDialog from '@/views/business/components/InternationalLogisticsInformationDialog.vue';
import InternationalShippingListDialog from '@/views/business/components/InternationalShippingListDialog.vue';
export default {
  name: 'InvoiceHasBeenReviewed',
  components: { InternationalLogisticsInformationDialog, InternationalApplyForDeliveryDialog, InvoiceProcessingSearchBox, InternationalShippingListDialog },
  data () {
    return {
      tableLoading: true,
      pageState: {
        pageSize: 10,
        currentPage: 1,
        total: 1
      },
      dialogVisibleFromShippingList: false,
      dialogVisibleFromLogistics: false,
      dialogVisibleFromApplyForDelivery: false,
      currentClickData: {},
      tableData: [],
      // 是否原始订单号码
      isOriginOrderNumber: false
    };
  },
  methods: {
    /**
     * value为搜索数据
     * @param value
     */
    ok (value) {
      if (value.data && value.data.status === '200') {
        this.tableLoading = false;
        this.pageState.pageSize = value.data.data.pageSize;
        this.pageState.total = value.data.data.total;
        this.tableData = value.data.data.list;
      } else {
        this.tableLoading = false;
      }
    },
    handlerSizeChange (val) {
      this.pageState.pageSize = val;
      this.$refs.searchBox.doSearch();
    },
    handlerCurrentChange (val) {
      this.pageState.currentPage = val;
      this.$refs.searchBox.doSearch();
    },
    refreshtable () {
      this.pageState.currentPage = 1;
      this.pageState.pageSize = 10;
      this.$refs.searchBox.clearSearchForm();
      // this.$refs.searchBox.doSearch();
    },
    //  点击申请发货单号
    lookApplyForDelivery (row, isOriginOrderNumber) {
      this.isOriginOrderNumber = isOriginOrderNumber;
      this.currentClickData = row;
      this.dialogVisibleFromApplyForDelivery = true;
    },
    /**
     * 合同详情
     * @param row
     */
    lookContract (row) {
      this.$router.push({
        name: 'businessDetails',
        params: { contractNum: row.contractNum },
        query: { distributeFlag: true, type: 3, isInternational: true, id: row.contractId, isShowInternationalService: row.civilInternational ? row.civilInternational : '0' }
      });
    },
    /**
     * 发货单号详情
     * @param row
     */
    lookShippingList (row) {
      // 把点击的当前行的数据 赋值传递
      this.currentClickData = row;
      this.dialogVisibleFromShippingList = true;
    },
    /**
     * 物流详情
     * @param row
     */
    lookLogistics (row) {
      // 写死数据
      this.currentClickData = { logisticsNum: 'JDVC14714247081', invoiceNum: 'FH202206281844' };
      this.dialogVisibleFromLogistics = true;
    },

    updateDialogVisibleFromApplyForDelivery (value) {
      this.dialogVisibleFromApplyForDelivery = value;
    },
    updateDialogVisibleFromShippingList (value) {
      this.dialogVisibleFromShippingList = value;
    },
    updateDialogVisibleFromLogistics (value) {
      this.dialogVisibleFromLogistics = value;
    }
  }
};
</script>

<style scoped>
.FontColor{
  color: #409EFF;
  cursor: pointer;
}
</style>
